<template>
  <div class="card border-0 shadow">
    <div class="card-body">
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex my-auto font-weight-bold">
          {{ label }}
        </div>
        <div class="d-flex">
          <button
            class="btn btn-primary d-flex"
            @click="openFileInput"
          >
            {{ customValue ? customValue.name : 'Choisir un fichier' }}
            <v-icon
              icon="upload-white"
              class="mx-1 my-auto"
            />
          </button>
        </div>
      </div>
    </div>
    <input
      ref="fileInput"
      class="d-none"
      :accept="accept"
      type="file"
      :disabled="inputDisabled"
      :class="customValidation"
      @change="setCustomModel($event)"
    >
    <transition
      tag="div"
      @enter="tf_slideDown"
      @leave="tf_slideUp"
    >
      <div
        v-if="isErrorMessage"
        class="invalid-feedback"
      >
        {{ errorMessage }}
      </div>
    </transition>
  </div>
</template>
<script>
import { isNil, debounce } from 'lodash-es';

import input from '@/mixins/input-2';
import { transform, ui } from '@/mixins';

import Icon from '@/components/common/helpers/Icon.vue';

export default {
  name: 'InputFile',
  components: {
    'v-icon': Icon,
  },
  mixins: [transform, input, ui],
  props: {
    accept: {
      type: String,
      default: '*',
    },
    errorMessage: {
      type: String,
      required: false,
      default: 'Veuillez compléter le champ',
    },
  },
  computed: {
    customValidation() {
      if (this.isEmpty(this.customValue)) return '';
      return this.inputValidation(this.customValue) ? '' : 'is-invalid';
    },
    isErrorMessage() {
      if (this.customModel === '') return false;
      return !this.inputValidation(this.customModel);
    },
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    isEmpty(value) {
      return value === '' || isNil(value) || Number.isNaN(value);
    },
    setCustomModel(value) {
      [this.customValue] = value.target.files;
      this.debouncer.cancel();
      const debouncerFunction = () => {
        this.$store.dispatch(
          this.setterPath,
          this.setterFunction(this.customValue, this.path || this.getterName),
        );
        this.setterCallback();
      };
      this.debouncer = debounce(debouncerFunction, this.debounceTimer);
      this.debouncer();
    },
  },
};
</script>
